import * as React from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import Typography from "@mui/material/Typography";
import { useParams, useLocation, useHistory } from "react-router-dom";

import { shutterbDashboardConstants } from "../../../../../constants";
import { NavigateToPath } from "../../../../../system";
import MyInfo from "./MyInfo";
import MySchedule from "./MySchedule";
import MyPortfolio from "./MyPortfolio";

const TabPanel = ({ children, value, index, ...other }) => (
  <div
    role="tabpanel"
    hidden={value !== index}
    id={`simple-tabpanel-${index}`}
    aria-labelledby={`simple-tab-${index}`}
    {...other}
    className="tab-panel-content"
  >
    {value === index && (
      <Box sx={{ p: 3 }}>
        <Typography>{children}</Typography>
      </Box>
    )}
  </div>
);

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

const a11yProps = (index) => {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
};

const MyProfileTab = () => {
  const history = useHistory();
  const location = useLocation();
  const { nestedTab } = useParams();

  const [value, setValue] = React.useState();

  React.useEffect(() => {
    setValue(
      nestedTab === shutterbDashboardConstants.MY_SCHEDULE
        ? shutterbDashboardConstants.MY_SCHEDULE_TAB_NUMBER
        : nestedTab === shutterbDashboardConstants.MY_PORTFOLIO
        ? shutterbDashboardConstants.MY_PORTFOLIO_TAB_NUMBER
        : nestedTab === shutterbDashboardConstants.MY_INFO
        ? shutterbDashboardConstants.MY_INFO_TAB_NUMBER
        : shutterbDashboardConstants.DEFAULT_TAB_NUMBER
    );
  }, [nestedTab]);

  const handleUpdateParams = (tab) => {
    let newLocation =
      location.pathname.slice(0, location.pathname.lastIndexOf("/") + 1) + tab;
    return newLocation;
  };

  return (
    <Box sx={{ width: "100%" }} className="sb-my-profil-con">
      <Box sx={{ borderBottom: 0, borderColor: "divider" }}>
        <Tabs
          value={value}
          scrollButtons
          variant="scrollable"
          allowScrollButtonsMobile
          aria-label="basic tabs example"
          className="sb-my-profile-tabs"
          sx={{
            "& .MuiTab-root": {
              minHeight: 35,
              padding: "5px 10px",
            },
          }}
        >
          <Tab
            label="schedule"
            onClick={() => {
              NavigateToPath(
                history,
                handleUpdateParams(shutterbDashboardConstants.MY_SCHEDULE)
              );
            }}
            {...a11yProps(0)}
            aria-selected={
              value === shutterbDashboardConstants.MY_SCHEDULE_TAB_NUMBER
            }
          />
          <div className="tab-divider" />
          <Tab
            label="portfolio"
            onClick={() => {
              NavigateToPath(
                history,
                handleUpdateParams(shutterbDashboardConstants.MY_PORTFOLIO)
              );
            }}
            {...a11yProps(1)}
            aria-selected={
              value === shutterbDashboardConstants.MY_PORTFOLIO_TAB_NUMBER
            }
          />
          <div className="tab-divider" />
          <Tab
            label="information"
            onClick={() => {
              NavigateToPath(
                history,
                handleUpdateParams(shutterbDashboardConstants.MY_INFO)
              );
            }}
            {...a11yProps(2)}
            aria-selected={
              value === shutterbDashboardConstants.MY_INFO_TAB_NUMBER
            }
          />
        </Tabs>
      </Box>
      <TabPanel
        value={value}
        index={shutterbDashboardConstants.MY_SCHEDULE_TAB_NUMBER}
      >
        <MySchedule />
      </TabPanel>
      <TabPanel
        value={value}
        index={shutterbDashboardConstants.MY_PORTFOLIO_TAB_NUMBER}
      >
        <MyPortfolio />
      </TabPanel>
      <TabPanel
        value={value}
        index={shutterbDashboardConstants.MY_INFO_TAB_NUMBER}
      >
        <MyInfo />
      </TabPanel>
    </Box>
  );
};

export default MyProfileTab;
